<template>
  <div class="animated fadeIn">
    <div class="row m-0">
      <div class="col-lg-12 left-side-product-box pb-3">
        <img
          v-if="product.product_edit.IconLocation"
          v-bind:src="ImageMainUrl"
          class="border p-3"
        />
        <span class="sub-img">
          <img
            v-if="product.product_edit.SmallImage1"
            v-bind:src="Image1Url"
            class="border p-2"
          />
          <img
            v-if="product.product_edit.SmallImage2"
            v-bind:src="Image2Url"
            class="border p-2"
          />
          <img
            v-if="product.product_edit.SmallImage3"
            v-bind:src="Image3Url"
            class="border p-2"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ProductImagePreview",
  methods: {
    setSelectedImage(_img) {
      return this.$store.state.global.apiResourceUrl + _img;
    }
  },
  created() {
    //console.log(this.$store.state.product.product_edit);
  },
  computed: {
    ...mapState(["product", "global"]),

    ImageMainUrl() {
      return (
        this.$store.state.global.apiResourceUrl +
        this.$store.state.product.product_edit.IconLocation
      );
    },
    Image1Url() {
      return (
        this.$store.state.global.apiResourceUrl +
        this.$store.state.product.product_edit.SmallImage1
      );
    },
    Image2Url() {
      return (
        this.$store.state.global.apiResourceUrl +
        this.$store.state.product.product_edit.SmallImage2
      );
    },
    Image3Url() {
      return (
        this.$store.state.global.apiResourceUrl +
        this.$store.state.product.product_edit.SmallImage3
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.left-side-product-box .sub-img img {
  margin-top: 5px;
  /*width: 83px;
  height: 100px;*/
  width: 33%;
  padding-top: 10px;
}
.pro-box-section .pro-box img {
  width: 100%;
  height: 200px;
}

@media (min-width: 360px) and (max-width: 640px) {
  .pro-box-section .pro-box img {
    height: auto;
  }
}
.left-side-product-box img {
  width: 100%;
}
.fit-image {
  width: 100%;
  object-fit: cover;
  height: 300px; /* only if you want fixed height */
}
</style>
